<template>
  <div style="flex: 1">
    <span class="TextSubTitle">{{ data.subtitulo }}</span>
    <ScrollView
      class="DashScrollContainer"
      :refreshing="refreshing"
      @onRefresh="onRefresh"
      :empty="isEmpty"
    >
      <CardNumIndicator
        v-for="(item, i) of data.data"
        :props="item"
        :key="i"
      />
      <template slot="Empty">
        <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
import CardNumIndicator from "./CardNumIndicator.vue";
export default {
  name: "IndicadorNumericoWrap",
  components: {
    CardNumIndicator
  },
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: [Array, Object],
      default: () => ({})
    }
  },
  computed: {
    isEmpty() {
      return this.data.data ? this.data.data.length === 0 : true;
    }
  },
  data() {
    return {
      
    };
  }
};
</script>

<style lang="scss" scoped>
.TextSubTitle {
  font-weight: bold;
  font-size: 22px;
  color: #000;
}
.DashScrollContainer {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
}
</style>
